export const UploadIcon = () => (
  <svg width="142" height="74" viewBox="0 0 142 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.88">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.50177 8.21597C3.2423 8.21597 0.599976 10.8653 0.599976 14.1334C0.599976 17.4016 3.2423 20.0509 6.50177 20.0509H40.2263C36.9669 20.0509 34.3245 22.7002 34.3245 25.9684C34.3245 29.2365 36.9669 31.8858 40.2263 31.8858H21.6778C18.4183 31.8858 15.776 34.5352 15.776 37.8033C15.776 41.0714 18.4183 43.7207 21.6778 43.7207H30.2556C34.3654 43.7207 37.697 46.3701 37.697 49.6382C37.697 51.3602 36.6436 52.9534 34.5369 54.4177C33.3426 55.2478 31.828 55.4312 30.4754 55.9657C28.2859 56.8308 26.7365 58.9705 26.7365 61.4731C26.7365 64.7413 29.3788 67.3906 32.6383 67.3906H102.617C105.876 67.3906 108.519 64.7413 108.519 61.4731C108.519 58.205 105.876 55.5557 102.617 55.5557H135.498C138.758 55.5557 141.4 52.9063 141.4 49.6382C141.4 46.3701 138.758 43.7207 135.498 43.7207H101.774C98.5142 43.7207 95.8718 41.0714 95.8718 37.8033C95.8718 34.5352 98.5142 31.8858 101.774 31.8858H122.851C126.111 31.8858 128.753 29.2365 128.753 25.9684C128.753 22.7002 126.111 20.0509 122.851 20.0509H89.1269C92.3864 20.0509 95.0287 17.4016 95.0287 14.1334C95.0287 10.8653 92.3864 8.21597 89.1269 8.21597H6.50177ZM6.50177 31.8858C3.2423 31.8858 0.599976 34.5352 0.599976 37.8033C0.599976 41.0714 3.2423 43.7207 6.50177 43.7207C9.76124 43.7207 12.4036 41.0714 12.4036 37.8033C12.4036 34.5352 9.76124 31.8858 6.50177 31.8858Z"
        fill="#DBDBFA"
      />
      <path d="M73.6731 73V39.8706" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.6061 9.64246C44.2424 9.64246 39.0829 14.802 39.0829 21.1657C39.0829 21.3861 39.103 21.6007 39.116 21.8197C39.1016 22.0818 39.0829 22.3469 39.0829 22.6061C33.3371 25.3602 29 31.9069 29 38.6739C29 48.0582 36.6774 55.7355 46.0616 55.7355H53.487L56.9785 11.5668C55.1535 10.3526 52.9626 9.64246 50.6061 9.64246Z"
        fill="#F1F1FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.4633 24.0465C99.2977 11.5164 89.1025 1 76.5334 1L90.8165 55.7355H96.5364C105.274 55.7355 112.423 48.5868 112.423 39.8507C112.423 32.1143 106.814 25.4308 99.4633 24.0465Z"
        fill="#DEDDFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.2638 24.0465C95.0982 11.5164 84.9029 1 72.3339 1C64.3267 1 63.3991 3.40404 59.2493 9.64245C57.4228 8.42819 57.2845 9.64245 54.928 9.64245C48.5629 9.64245 43.4048 14.802 43.4048 21.1657C43.4048 21.3861 43.4249 21.6007 43.4379 21.8197C43.4235 22.0818 43.4048 22.3469 43.4048 22.6061C37.659 25.3602 33.3219 31.9069 33.3219 38.6739C33.3219 48.0582 40.9993 55.7355 50.3835 55.7355H57.8089H86.617H92.3369C101.074 55.7355 108.223 48.5868 108.223 39.8507C108.223 32.1143 102.614 25.4308 95.2638 24.0465Z"
        fill="white"
      />
      <path
        d="M99.6256 24.0466C99.6256 24.0466 95.9741 23.5064 92.4192 24.0466"
        stroke="#8A88FE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.1237 21.1657C39.1237 14.802 44.2832 9.64246 50.6469 9.64246C57.0107 9.64246 62.1702 14.802 62.1702 21.1657"
        stroke="#8A88FE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.9784 55.7355H96.6997C105.436 55.7355 112.584 48.5868 112.584 39.8507C112.584 32.1143 106.976 25.4308 99.6251 24.0465C99.4609 11.5164 89.2657 1 76.6953 1C68.688 1 61.1705 5.32843 57.0193 11.5668C55.1943 10.3526 53.0034 9.64245 50.6469 9.64245C44.2832 9.64245 39.1236 14.802 39.1236 21.1657C39.1236 21.3861 39.1438 21.6007 39.1568 21.8197C39.1424 22.0818 39.1236 22.3469 39.1236 22.6061C33.3778 25.3602 29.0408 31.9069 29.0408 38.6739C29.0408 48.0582 36.7182 55.7355 46.1024 55.7355H53.5277"
        stroke="#8A88FE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.2531 71.58V38.4506"
        stroke="#8A88FE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.2531 38.4506L83.7763 49.9739"
        stroke="#8A88FE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.7297 49.9739L72.253 38.4506"
        stroke="#8A88FE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
